/**
 * Gets the total height of the element passed as argument
 * @param {HTMLElement} element single html element
 * @returns {number} The total height of the element passed (in px)
 */
function getElementHeight(element) {
  let totalHeight = 0;
  const style = getComputedStyle(element);
  totalHeight += element.offsetHeight;
  totalHeight += parseInt(style.marginTop, 10);
  totalHeight += parseInt(style.marginBottom, 10);
  return totalHeight;
}

/**
 * Gets the total height of the elements passed as argument
 * @param {string} selector selector to check
 * @returns {number} The total height of the elements passed (in px)
 */
function getTotalHeightBySelector(selector) {
  let totalHeight = 0;
  document.querySelectorAll(selector).forEach((el) => {
    totalHeight += getElementHeight(el);
  });
  return totalHeight;
}

module.exports = {
  getTotalHeightBySelector,
};
